export default commomImport => [{
  path: `product-list`,
  name: 'ProductList',
  meta: {
    title: 'product.productList',
    noCache: true
  },
  //  全部订单
  component: commomImport('product-manager/product-list')
}];
